import 'bootstrap/dist/css/bootstrap.min.css';
import {useState} from "react";
import {toast} from "react-toastify";
import {useDispatch} from "react-redux";
//import {createOrder} from "../../../redux/slices/products";

import {useInventory} from "../../context/InventoryContext";
import FormCart from "./carts/Form.Cart";


export default function CreateCart({show, onClose, orderData}) {
    const dispatch = useDispatch();
    const [isLoading, setIsLoading] = useState(false)
    const {hide, filters, addToCartForFutureOder,addToValidationCartForFutureOder} = useInventory();
    const handleClosing = () => onClose && onClose()


    const handleSubmit = (order) => {
        /*if (order.Purchaser === null) {
            toast.error('Veuilez selectionez un utilisateur')
            return
        }

        if (order.Items === null || (order.Items && order.Items.length === 0)) {
            toast.error('Veuilez selectionez au moins un produit')
            return
        }*/


        setIsLoading(true)
        /*dispatch( */addToCartForFutureOder(order/*{
            data: order, onResolve: () => {
                toast.success('Fait!')
                setIsLoading(false)
                handleClosing()
            }
        })*/)
        setIsLoading(false)
        handleClosing()

    }

    const handleForvalidation = (order) => {
        /*if (order.Purchaser === null) {
            toast.error('Veuilez selectionez un utilisateur')
            return
        }

        if (order.Items === null || (order.Items && order.Items.length === 0)) {
            toast.error('Veuilez selectionez au moins un produit')
            return
        }*/


        setIsLoading(true)
        /*dispatch( */addToValidationCartForFutureOder(order/*{
            data: order, onResolve: () => {
                toast.success('Fait!')
                setIsLoading(false)
                handleClosing()
            }
        })*/)
        setIsLoading(false)
        handleClosing()

    }

    return (
        <>

            <FormCart
                title={'Ajout au panier'}
                show={show}
                order={orderData}
                onClose={handleClosing}
                onSubmit={handleSubmit}
                onValidation={handleForvalidation}
                isLoading={isLoading}
            />
        </>
    )
}
